// extracted by mini-css-extract-plugin
module.exports = {"image":"hoa-module--image--XotMX","button":"hoa-module--button--1RrUA"};